import React from 'react'
import { connect } from 'react-redux'
import ToggleMenu from '../../../components/layout/actions/ToggleMenu'
import { logout } from '../../actions/login'
import { showFullscreenLoader } from '../../actions/form'

import styles from './Header.module.css'

const Header = ({ appName, logout, showFullscreenLoader }) =>{
  const handleLogout = (event) => {
    event.preventDefault()
    logout()
    showFullscreenLoader('Logging out...')
    setTimeout(() => {
      window.location.href = '/login?loggedOut=true'
    }, 1000)
  }
  return (
  <header id="header">
    
    <div className={styles.logo} />
    <h1 className={styles.appName}>
      {appName}
    </h1>
    <div
      className={`pull-right ${styles.pullRight}`} /* pulled right: nav area */
    >
      <ToggleMenu className="btn-header pull-right" /* collapse menu button */ />
      {/* #MOBILE */}
      {/*  Top menu profile link : this shows only when top menu is active */}
      <ul
        id="mobile-profile-img"
        className="header-dropdown-list hidden-xs padding-5"
      >
        <li className="">
          <a
            href="#"
            className="dropdown-toggle no-margin userdropdown"
            data-toggle="dropdown"
          >
            <img
              src="styles/img/avatars/sunny.png"
              alt="John Doe"
              className="online"
            />
          </a>
          <ul className="dropdown-menu pull-right">
            <li>
              <a href="#" className="padding-10 padding-top-0 padding-bottom-0">
                <i className="fa fa-cog" /> Setting
              </a>
            </li>
            <li className="divider" />
            <li>
              <a
                href="/views/profile"
                className="padding-10 padding-top-0 padding-bottom-0"
              >
                {' '}<i className="fa fa-user" />
                <u>P</u>rofile
              </a>
            </li>
            <li className="divider" />
            <li>
              <a
                href="#"
                className="padding-10 padding-top-0 padding-bottom-0"
                data-action="toggleShortcut"
              >
                <i className="fa fa-arrow-down" /> <u>S</u>hortcut
              </a>
            </li>
            <li className="divider" />
            <li>
              <a
                href="#"
                className="padding-10 padding-top-5 padding-bottom-5"
                // onClick={event => {
                //   event.preventDefault()
                //   logout()
                // }}
                onClick={handleLogout}
              >
                <i className="fa fa-sign-out fa-lg" />{' '}
                <strong>
                  <u>L</u>ogout
                </strong>
              </a>
            </li>
          </ul>
        </li>
      </ul>
      {/* logout button */}
      <div id="logout" className="btn-header transparent pull-right">
        <span>
          <a
            href="#"
            title="Sign Out"
            // onClick={event => {
            //   event.preventDefault()
            //   logout()
            // }}
            onClick={handleLogout}
          >
            <i className="fa fa-sign-out" />
          </a>
        </span>
      </div>
    </div>
    {/* end pulled right: nav area */}
  </header>
  )
}
function mapDispatchToProps(dispatch) {
  return {
    logout() {
      dispatch(logout())
    },
    showFullscreenLoader(message) {
      dispatch(showFullscreenLoader(message))
    }
  }
}

export default connect(null, mapDispatchToProps)(Header)
